import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { IncidentCategory, Organization, Permission, PinActivationDialogData } from '../interfaces/pin-activation.types';
// import { PinActivationDialogData, Organization, IncidentCategory, Permission } from './pin-activation.types';

@Injectable({ providedIn: 'root' })
export class PinActivationService {
  private dialogDataSubject = new BehaviorSubject<PinActivationDialogData | null>(null);
  private organizationsSubject = new BehaviorSubject<Organization[]>([]);
  private incidentCategoriesSubject = new BehaviorSubject<IncidentCategory[]>([]);
  private permissionsSubject = new BehaviorSubject<Permission | null>(null);

  dialogData$ = this.dialogDataSubject.asObservable();
  organizations$ = this.organizationsSubject.asObservable();
  incidentCategories$ = this.incidentCategoriesSubject.asObservable();
  permissions$ = this.permissionsSubject.asObservable();

  setDialogData(data: PinActivationDialogData) {
    this.dialogDataSubject.next(data);
  }

  setOrganizations(orgs: Organization[]) {
    this.organizationsSubject.next(orgs);
  }

  setIncidentCategories(categories: IncidentCategory[]) {
    this.incidentCategoriesSubject.next(categories);
  }

  setPermissions(permissions: Permission) {
    this.permissionsSubject.next(permissions);
  }
}
export class PinActivationDialogOptions {
  type: string;
  incidentId: string;

  constructor(type: string, incidentId: string) {
    this.type = type;
    this.incidentId = incidentId;
  }

  getType(): string {
    return this.type;
  }
}